export const PREVIEW_IFRAME_BASE_WIDTH = 1280;
export const PREVIEW_IFRAME_BASE_HEIGHT = 800;
